<template>
  <div>
    <el-card :id="`${team1}-v-${team2}`" class="tw-h-40 tw-mt-10" @click="$emit('click')">
      <!-- FOR FEED BUTTON  -->
      <slot />
      <div class="match-title">
        <p>
          <strong> {{ comp }} </strong>
        </p>
        <p>{{ title }}</p>
      </div>
      <div class="versus-wrapper">
        <div class="versus">
          <div class="team" @click="$emit('open_team', { team: match.homeTeam, match })">
            <div class="club-logo">
              <img :src="getS3URL(club1._id)" @error="displayPlaceholder" :alt="team1" />
            </div>
            <div class="team-name left">
              <span>{{ team1 }}</span>
            </div>
          </div>
          <div class="time-wrap">
            <div class="scores d-flex">
              <div class="score">
                <component
                  class="font-22"
                  :is="parseInt(score1) > parseInt(score2) ? 'b' : 'span'"
                  >{{ score1 }}</component
                >
              </div>
              <div class="caps grey">
                {{ time }}
                <br />
                {{ gameState ? gameState : status }}
              </div>
              <div class="score">
                <component
                  class="font-22"
                  :is="parseInt(score2) > parseInt(score1) ? 'b' : 'span'"
                  >{{ score2 }}</component
                >
              </div>
            </div>
          </div>
          <div class="team" @click="$emit('open_team', { team: match.awayTeam, match })">
            <div class="club-logo">
              <img :src="getS3URL(club2._id)" @error="displayPlaceholder" :alt="team2" />
            </div>
            <div class="team-name right">
              <span>{{ team2 }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="match-title">{{ place || "NA" }} {{ fieldNo ? `, Field ${fieldNo}` : "" }}</div>
    </el-card>
    <el-card class="card">
      <div slot="header" class="clearfix" @click="toggleContent">
        <span class="card-header">Referee Appointments</span>
        <i class="el-icon-arrow-down" :class="{ 'is-active': isExpanded }"></i>
      </div>
      <div v-show="isExpanded">
        <select v-model="refereeData" class="tw-mx-6 sm:tw-w-72 tw-w-full tw-h-10 tw-border tw-capitalize">
          <option disabled selected :value="{}">Name</option>
          <option
            v-for="ref in availableReferees"
            :label="`${ref.firstName} ${ref.lastName}`"
            :value="ref"
            :key="ref._id"
          >
            {{ `${ref.firstName} ${ref.lastName}` }}
          </option>
        </select>
        <select v-model="refereeRole" class="tw-mx-6 sm:tw-w-72 tw-w-full tw-h-10 tw-border">
          <option disabled selected :value="emptyRole">Role</option>
          <option v-for="(role, index) in types" :label="`${role.name} `" :value="role.role" :key="index">
            {{ `${role.name}` }}
          </option>
        </select>

        <button
          class="tw-justify-center sm:tw-w-72 tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  hover:tw-bg-green-300 hover:tw-text-black"
          @click="addReferee"
        >
          Add Official
        </button>
      </div>
      <div class="card-content" v-if="refereeTypes && refereeTypes.length > 0">
        <div class="max-w-3xl mx-auto">
          <div class="tw-my-6 tw-bg-white tw-rounded tw-shadow-md">
            <div class="tw-overflow-x-auto">
              <table class="tw-min-w-full tw-bg-white">
                <thead>
                  <tr class="tw-bg-gray-100">
                    <th
                      class="tw-px-6 tw-py-3 tw-text-xs tw-font-semibold tw-tracking-wider tw-text-left tw-text-gray-600 tw-uppercase"
                    >
                      Name
                    </th>
                    <th
                      class="tw-px-6 tw-py-3 tw-text-xs tw-font-semibold tw-tracking-wider tw-text-left tw-text-gray-600 tw-uppercase"
                    >
                      Role
                    </th>

                    <th
                      class="tw-px-6 tw-py-3 tw-text-xs tw-font-semibold tw-tracking-wider tw-text-left tw-text-gray-600 tw-uppercase"
                    >
                      Remove
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    class="hover:tw-bg-gray-200"
                    v-for="(referee, index) in refereeTypes"
                    :key="index"
                  >
                    <td
                      class="tw-px-6 tw-py-4 tw-text-sm tw-font-medium tw-text-gray-900 tw-whitespace-nowrap"
                    >
                      {{ referee.firstName }} {{ referee.lastName }}
                    </td>
                    <td class="tw-px-6 tw-py-4 tw-text-sm tw-text-gray-500 tw-whitespace-nowrap">
                      {{ formatData(referee.role) }}
                    </td>

                    <td class="tw-px-6 tw-py-4 tw-text-sm tw-whitespace-nowrap">
                      <button
                        class="tw-px-4 tw-py-2 tw-font-bold tw-text-white tw-bg-red-500 tw-rounded hover:tw-bg-red-700"
                        @click="removeReferee(referee)"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import dayjs from "@/utils/dayjs";
import { getS3URL } from "../utils/utilities";
import { EventBus } from "../bus";

export default {
  name: "RefereeMatchCard",
  props: ["match"],
  data() {
    return {
      getS3URL,
      refereeData: {},
      name: "",
      refereeRole: "",
      emptyRole: "",
      isExpanded: false,
      referee: "",
      refereeTypes: [],
      types: [
        { role: "touch-judge", name: "Touch Judge" },
        { role: "in-goal-judge", name: "In Goal Judge" },
        { role: "referee", name: "Referee" },
        { role: "video-referee", name: "Video Referee" },
        { role: "referee-coach", name: "Referee Coach" },
        { role: "standby-referee", name: "Standby Referee" },
        { role: "standby-touch-judge", name: "Interchange Official" },
        { role: "referee-trainer", name: "Referee Trainer" },
      ],
      possibleReferee: [],
    };
  },
  mounted() {
    EventBus.$on("gamestate/update", () => {
      this.$forceUpdate();
    });
    this.getReferees();
  },
  computed: {
    title() {
      return `Round ${this.match.round.number} ${this.matchDate(this.match.dateTime)}`;
    },
    comp() {
      return this.match.competition.name;
    },
    fieldNo() {
      return this.match.meta && this.match.meta.fieldNo ? this.match.meta.fieldNo : false;
    },
    team1() {
      if (this.match.meta && this.match.meta.isTba) return "TBA";
      return this.match.homeTeam ? this.match.homeTeam.name : "BYE";
    },
    club1() {
      return this.match.homeTeam && this.match.homeTeam.orgtree && this.match.homeTeam.orgtree.club
        ? this.match.homeTeam.orgtree.club
        : { _id: "" };
    },
    team2() {
      if (this.match.meta && this.match.meta.isTba) return "TBA";
      return this.match.awayTeam ? this.match.awayTeam.name : "BYE";
    },
    club2() {
      return this.match.awayTeam && this.match.awayTeam.orgtree && this.match.awayTeam.orgtree.club
        ? this.match.awayTeam.orgtree.club
        : { _id: "" };
    },
    time() {
      return this.matchTime(this.match.dateTime);
    },
    place() {
      return this.match.venue ? this.match.venue.name : "";
    },
    score1: {
      cache: false,
      get() {
        return this.match.scores.homeTeam;
      },
    },
    score2: {
      cache: false,
      get() {
        return this.match.scores.awayTeam;
      },
    },
    status() {
      return this.match.status;
    },
    gameState() {
      return this.match && this.match.gameStates && this.match.gameStates.length > 0
        ? this.match.gameStates.slice(-1)[0].name
        : undefined;
    },
    availableReferees() {
      return this.possibleReferee.filter(
        (ref) => !this.refereeTypes.some((assigned) => assigned._id === ref._id)
      );
    },
  },
  methods: {
    formatData(role) {
      const displayRole = this.types.find((t) => t.role === role);
      return displayRole.name;
    },
    addReferee() {
      if (!this.refereeData._id || !this.refereeRole) {
          this.$message.error("Please select both a referee and a role.");
          return;
        }

        const existingReferee = this.refereeTypes.find(
        (ref) => ref._id === this.refereeData._id
        );
      if (existingReferee) {
        this.$message.error(
          `${this.refereeData.firstName} ${this.refereeData.lastName} is already assigned as ${existingReferee.role}.`
        );
        return;
      };

      const appointment = {
        role: this.refereeRole,
        _id: this.refereeData._id,
        firstName: this.refereeData.firstName,
        lastName: this.refereeData.lastName,
      };

      const canAddReferee = this.checkRefereeCondition(this.refereeRole);

      if (canAddReferee && appointment) {
        if (this.refereeTypes && this.refereeTypes.length > 0)
          this.refereeTypes = [...this.refereeTypes, appointment];
        else {
          this.refereeTypes = [];
          this.refereeTypes.push(appointment);
        }

        this.refereeData = {};
        this.refereeRole = "";
        this.saveRefereeList();
      } else {
        this.$alert(`We can't add more of the ${this.refereeRole} role.`);
      }
    },
    checkRefereeCondition(role) {
      let countForRole;
      switch (role) {
        case "touch-judge":
          countForRole = 2;
          break;
        case "in-goal-judge":
          countForRole = 2;
          break;
        case "referee":
          countForRole = 2;
          break;
        case "video-referee":
          countForRole = 2;
          break;
        case "referee-coach":
          countForRole = 1;
          break;
        case "standby-referee":
          countForRole = 1;
          break;
        case "standby-touch-judge":
          countForRole = 2;
          break;
        case "referee-trainer":
          countForRole = 1;
          break;
      }
      if (this.refereeTypes && this.refereeTypes.length > 0) {
        const rolesAlreadyAdded = this.refereeTypes.filter((rt) => rt.role === role);
        if (rolesAlreadyAdded && rolesAlreadyAdded.length < countForRole) return true;
        else return false;
      } else return true;
    },
    async saveRefereeList() {
      this.match.appointments = this.refereeTypes;
      const match = await this.$http.put(`/nrl/api/v1/admin/matches/${this.match._id}`, this.match);
    },
    getReferees() {
      const url = `/nrl/api/v1/admin/competitions/${this.match.competition._id}/referees`;
      this.$http
        .get(url)
        .then((response) => {
          this.possibleReferee = response.data.members;
        })
        .catch(() => {
          this.$customError();
        });
    },

    removeReferee(referee) {
      const totalReferees = this.refereeTypes;
      if (referee && referee._id) {
        this.refereeTypes = totalReferees.filter((r) => r._id !== referee._id);
        this.saveRefereeList();
      }
    },
    async toggleContent() {
      this.isExpanded = !this.isExpanded;
      const match = await this.$http.get(`/nrl/api/v1/admin/matches/${this.match._id}`);
      if (match && match.data && match.data.data) {
        const appointments = match.data.data.appointments;
        this.refereeTypes = appointments;
      }
    },
    displayPlaceholder(event) {
      event.target.src = require("../assets/shield_black.svg");
    },
    matchDate(dateTime) {
      return dayjs(dateTime).format("dddd Do MMMM");
    },
    matchTime(dateTime) {
      return dayjs(dateTime).format("h:mma");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 5px;
  //   padding-bottom: 2rem;
}

::v-deep .el-card__header {
  padding: 10px 20px;
  border-bottom: 1px solid #ebeef5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.grey {
  color: grey;
}
.versus-wrapper {
  display: flex;
}
.time-wrap {
  min-width: 100px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding: 30px;
  .scores {
    flex-grow: 1;
    justify-content: space-between;
    max-width: 150px;
    font-weight: normal;
  }
  @media (max-width: $sm) {
    font-size: 0.7em;
    padding: 1px;
  }
}

.versus {
  flex-grow: 1;
  max-width: 95%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  height: 80px;
}

.team {
  width: 24%;
  text-align: center;
}

.club-logo {
  width: 60px;
  margin: 0 auto;
  img {
    max-width: 100%;
    height: auto;
  }
}

.font-22 {
  font-size: 22px;
  @media (max-width: $sm) {
    width: 150px;
    font-size: 2em;
  }
}
.score {
  @media (max-width: $sm) {
    margin: 0px 0px;
    width: 20px;
  }
}

.team-name {
  @media (max-width: $sm) {
    font-size: 0.7em;
  }
}

.versus {
  font-weight: 500;
  display: flex;

  * {
    margin-top: auto;
    margin-bottom: auto;
  }
}

.block {
  min-width: 50px;
}
.match-title {
  font-size: 0.7em;
  color: grey;
  text-align: center;
}
.caps {
  text-transform: uppercase;
  text-align: center;
}
</style>
